import React from "react";
import { Router, Route, Switch } from "react-router-dom";
import { Container } from "reactstrap";

import PrivateRoute from "./components/PrivateRoute";
import Loading from "./components/Loading";
import NavBar from "./components/NavBar";
import Footer from "./components/Footer";
import Home from "./views/Home";
import Profile from "./views/Profile";
import ExternalApi from "./views/Dashboard";
import Edit from "./views/Edit";
import Service from "./views/Service";
import Renew from "./views/Renew";
import { useAuth0 } from "./react-auth0-spa";
import history from "./utils/history";

// styles
import "./App.css";

// fontawesome
import initFontAwesome from "./utils/initFontAwesome";
initFontAwesome();

const App = () => {
  const { loading } = useAuth0();

  if (loading) {
    return <Loading />;
  }

  return (
    <Router history={history}>
      <div id="app" className="d-flex flex-column h-100">
        <NavBar />
        <Container className="flex-grow-1 mt-5">
          <Switch>
            <Route path="/" exact component={Home} />
            <PrivateRoute location="/profile" path="/profile" component={Profile} />
            <PrivateRoute location="/dashboard" path="/dashboard" component={ExternalApi} />
            <PrivateRoute location="/service" path="/service" component={Service} />
            <PrivateRoute location="/renew" path="/renew" component={Renew} />
            <PrivateRoute location="/edit" path="/edit/:id" component={Edit}  />
          </Switch>
        </Container>
        <Footer />
      </div>
    </Router>
  );
};

export default App;
